<template>
  <div class="py-4">
    <p class="ui-muted">Solicitações de acesso à reunião integrada ao Zoom. Links externos e acessos diretos ao Zoom não geram registros nesta lista.</p>
    <v-alert v-if="error" type="error" text>{{ error }}</v-alert>
    <ui-table-card>
      <v-data-table :headers="headers" :items="rows" :loading="loading" :options.sync="options" :server-items-length="total" disable-sort hide-default-footer no-data-text="Nenhum acesso registrado.">
        <template v-slot:[`item.created_at`]="{item}">{{ item.created_at | defaultDate('DD/MM/YYYY HH:mm [BRT]') }}</template>
        <template v-slot:[`item.actor_name`]="{item}"><span class="ui-cell-main">{{ item.actor_name }}</span></template>
        <template #footer>
          <ui-pagination :total="total" :page="options.page" :items-per-page="options.itemsPerPage" :items-per-page-options="[25]" :disabled="loading" @update:page="options.page = $event" />
        </template>
      </v-data-table>
    </ui-table-card>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  props: ['meetingId'],
  data: () => ({ loading: false, error: '', rows: [], total: 0, options: {page: 1, itemsPerPage: 25}, headers: [
    {text: 'Quando', value: 'created_at'}, {text: 'Solicitante', value: 'actor_name'}, {text: 'Credor', value: 'participant_name'},
    {text: 'Ação', value: 'action'}, {text: 'Resultado', value: 'result'}, {text: 'Motivo', value: 'reason'}].map(item => ({...item, sortable: false})) }),
  watch: { options: {handler: 'load', deep: true}, meetingId: 'load' },
  mounted() { this.load(); },
  methods: { async load() {
    if (!this.meetingId) return;
    this.loading = true; this.error = '';
    try { const response = await axios.get(`/api/admin/general-meetings/${this.meetingId}/access-logs`, {params: {page: this.options.page}}); this.rows = response.data.content.data; this.total = response.data.content.total; }
    catch (error) { this.error = this.$codes(error); }
    finally { this.loading = false; }
  } }
};
</script>
